import apiClient from '@/lib/api-client';

/**
 * Story 1 van spec-klant-zoeken-op-naam (webkant): de klantenlijst voor de klantkiezer komt in één
 * keer binnen (153 klanten op 22-09-2026) en wordt daarna in de browser gefilterd — er gaat dus
 * geen verzoek per toetsaanslag uit, en het endpoint kent geen zoekparameter.
 */
export interface ClientDirectoryEntry {
  gln: string;
  companyName: string;
}

export async function getClientDirectory(): Promise<ClientDirectoryEntry[]> {
  const response = await apiClient.get<{ data?: ClientDirectoryEntry[] }>('/clients/directory');
  const klanten = response.data?.data;
  // Een onbruikbaar antwoord is een storing, geen lege klantenlijst: alleen zo kan het klantveld
  // terugvallen op het nummer met de melding dat namen nu niet beschikbaar zijn.
  if (!Array.isArray(klanten)) throw new Error('Klantenlijst niet beschikbaar');
  return klanten;
}
